(function () {
  'use strict';
  if (window.__ssCartUpsellController) return;
  window.__ssCartUpsellController = true;

  var ROOT = 'section.ss-cu[data-ss-cart-upsell]';
  var currentCart = null;
  var pending = null;
  var errorMessage = '';
  var interactionRevision = 0;
  var savedScroll = 0;
  var lastTrack = null;

  function block() { return document.querySelector(ROOT); }
  function validCart(value) { return value && Array.isArray(value.items); }
  function drawerApi() { return window.SoulyshineDrawer; }

  function readJson(element) {
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  }

  function catalogFor(section) {
    return readJson(section && section.querySelector('[data-ss-cu-catalog]'));
  }

  function latestCart() {
    var api = drawerApi();
    var authoritative = api && typeof api.getCart === 'function' && api.getCart();
    if (validCart(authoritative)) return authoritative;
    if (validCart(currentCart)) return currentCart;
    var section = block();
    var scope = section && section.closest('cart-drawer') || document;
    var seed = readJson(scope.querySelector('[data-ss-cart-state]'));
    return validCart(seed) ? seed : { items: [], currency: 'USD' };
  }

  function offersFor(cart, catalog) {
    var rules = window.SSCartUpsellRules;
    return rules && catalog ? rules.buildOffers(cart, catalog) : [];
  }

  function textElement(tag, className, text) {
    var element = document.createElement(tag);
    element.className = className;
    element.textContent = text == null ? '' : String(text);
    return element;
  }

  function safeImage(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (error) { return ''; }
  }

  function money(cents, cart) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    var currency = cart.currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
    var locale = document.documentElement.lang || window.navigator.language || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount / 100);
    } catch (error) {
      return String(currency) + ' ' + (amount / 100).toFixed(2);
    }
  }

  function personalization(offer) {
    var properties = offer.properties || {};
    return Object.keys(properties).filter(function (key) {
      var value = properties[key];
      return key.charAt(0) !== '_' && /\b(?:names?\d*|engraving|text|initials?)\b/i.test(key) &&
        (typeof value === 'string' || typeof value === 'number') && String(value).trim() &&
        !/^(?:https?:)?\/\//i.test(String(value).trim());
    }).slice(0, 2).map(function (key) {
      var value = String(properties[key]).trim();
      return key + ': ' + (value.length > 60 ? value.slice(0, 57) + '…' : value);
    }).join(' · ');
  }

  function isReadOnlyOffer(offer) {
    return !!(offer.externalAdded && !offer.addedLineKeys.length);
  }

  function makeCard(offer, cart) {
    var card = textElement('article', 'ss-cu__card', '');
    var meta = offer.material;
    var detail = offer.kind === 'necklace' ? personalization(offer) : '';
    var image = document.createElement('img');
    image.className = 'ss-cu__image';
    image.width = 52;
    image.height = 52;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = offer.title + ', ' + meta;
    var imageSource = safeImage(offer.image);
    if (imageSource) image.src = imageSource;
    else image.alt = '';
    if (imageSource) {
      var zoom = document.createElement('button');
      zoom.type = 'button';
      zoom.className = 'ss-cu__zoom ink-preview-btn';
      zoom.setAttribute('aria-label', 'View larger image of ' + offer.title + ', ' + meta);
      zoom.setAttribute('aria-haspopup', 'dialog');
      zoom.setAttribute('aria-controls', 'ink-preview-lightbox');
      zoom.title = 'View larger image';
      // Catalog thumbnails use Shopify image_url; request the same image at full viewing size.
      var fullImage = new URL(imageSource);
      fullImage.searchParams.set('width', '1600');
      zoom.setAttribute('data-image', fullImage.href);
      zoom.setAttribute('data-product-title', offer.title + ' · ' + meta);
      zoom.appendChild(image);
      var zoomIcon = document.createElement('span');
      zoomIcon.className = 'ss-cu__zoom-icon';
      zoomIcon.setAttribute('aria-hidden', 'true');
      zoomIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5M10.5 7.5v6M7.5 10.5h6"/></svg>';
      zoom.appendChild(zoomIcon);
      card.appendChild(zoom);
    } else card.appendChild(image);

    var info = textElement('div', 'ss-cu__info', '');
    var title = textElement('a', 'ss-cu__title', offer.title);
    title.href = '/products/' + encodeURIComponent(offer.handle) + '?variant=' + encodeURIComponent(String(offer.variantId));
    title.title = offer.title;
    info.appendChild(title);
    info.appendChild(textElement('div', 'ss-cu__meta', meta));
    if (offer.sourceTitle) {
      var source = textElement('div', 'ss-cu__source', detail ? detail + ' · ' + offer.sourceTitle : offer.sourceTitle);
      source.title = offer.sourceTitle + (detail ? ' · ' + detail : '');
      info.appendChild(source);
    }
    info.appendChild(textElement('div', 'ss-cu__price', money(offer.price, cart)));
    card.appendChild(info);

    var label = textElement('label', 'ss-cu__toggle', '');
    var checkbox = document.createElement('input');
    var checked = !!(offer.addedLineKeys.length || offer.externalAdded);
    var readOnly = isReadOnlyOffer(offer);
    checkbox.type = 'checkbox';
    checkbox.setAttribute('data-ss-cu-check', '');
    checkbox.setAttribute('data-ss-cu-offer', offer.id);
    checkbox.checked = checked;
    checkbox.disabled = !!(readOnly || pending);
    var action = readOnly ? 'Already in your cart: ' : checked ? 'Remove added ' : 'Add ';
    checkbox.setAttribute('aria-label', action + offer.title + ', ' + meta +
      (detail ? ', ' + detail : '') + (offer.sourceTitle ? ', matching ' + offer.sourceTitle : ''));
    label.appendChild(checkbox);
    label.appendChild(textElement('span', 'ss-cu__state', readOnly ? 'Already in cart' : checked ? 'Added' : 'Add'));
    card.appendChild(label);
    return card;
  }

  function direction(button) {
    return /^(?:-1|prev|previous|back|left)$/i.test(button.getAttribute('data-direction') || '') ? -1 : 1;
  }

  function updateArrows(section) {
    if (!section) return;
    var track = section.querySelector('.ss-cu__track');
    if (!track) return;
    var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    section.querySelectorAll('.ss-cu__arrow').forEach(function (button) {
      var previous = direction(button) < 0;
      button.type = 'button';
      button.setAttribute('aria-label', previous ? 'Previous add-on' : 'Next add-on');
      button.disabled = maximum <= 1 || (previous ? track.scrollLeft <= 1 : track.scrollLeft >= maximum - 1);
    });
  }

  function status(message) {
    var section = block();
    var live = section && section.querySelector('.ss-cu__status');
    if (live) live.textContent = message || '';
  }

  function render(cart) {
    if (validCart(cart)) currentCart = cart;
    var section = block();
    if (!section) return;
    var track = section.querySelector('.ss-cu__track');
    if (!track) return;
    var catalog = catalogFor(section);
    var offers = offersFor(currentCart || latestCart(), catalog);
    if (lastTrack === track) savedScroll = track.scrollLeft;
    lastTrack = track;
    var contents = document.createDocumentFragment();
    offers.forEach(function (offer) { contents.appendChild(makeCard(offer, currentCart || latestCart())); });
    track.replaceChildren(contents);
    section.setAttribute('data-count', String(offers.length));
    section.setAttribute('aria-busy', pending ? 'true' : 'false');
    section.hidden = offers.length === 0 && !errorMessage;
    var error = section.querySelector('.ss-cu__error');
    if (error) {
      error.textContent = errorMessage;
      error.hidden = !errorMessage;
    }
    track.scrollLeft = savedScroll;
    updateArrows(section);
    window.requestAnimationFrame(function () {
      if (section.isConnected) updateArrows(section);
    });
  }

  function canRestoreFocus(section) {
    if (!section || section.hidden || section.closest('[hidden], [aria-hidden="true"]')) return false;
    var drawer = section.closest('cart-drawer');
    if (drawer && !drawer.classList.contains('active')) return false;
    if (window.SoulyshineCartUI && typeof window.SoulyshineCartUI.isOverlayOpen === 'function' &&
        window.SoulyshineCartUI.isOverlayOpen()) return false;
    return section.getClientRects().length > 0;
  }

  function restoreCheckboxFocus(action) {
    if (!action.focus || action.revision !== interactionRevision) return;
    window.requestAnimationFrame(function () {
      if (action.revision !== interactionRevision) return;
      var section = block();
      if (!canRestoreFocus(section)) return;
      var checkbox = Array.from(section.querySelectorAll('[data-ss-cu-check]')).find(function (input) {
        return input.getAttribute('data-ss-cu-offer') === action.id;
      });
      if (checkbox && !checkbox.disabled) checkbox.focus({ preventScroll: true });
    });
  }

  function isDrawerBusy(section) {
    var drawer = section.closest('cart-drawer');
    return drawer && drawer.getAttribute('aria-busy') === 'true';
  }

  async function onChange(event) {
    var checkbox = event.target;
    if (!checkbox.matches || !checkbox.matches('[data-ss-cu-check]')) return;
    var section = checkbox.closest(ROOT);
    if (!section) return;
    event.stopPropagation();
    if (pending || isDrawerBusy(section)) {
      render(latestCart());
      return;
    }
    var catalog = catalogFor(section);
    var id = checkbox.getAttribute('data-ss-cu-offer');
    var offer = offersFor(latestCart(), catalog).find(function (candidate) { return candidate.id === id; });
    if (!offer || isReadOnlyOffer(offer)) {
      render(latestCart());
      return;
    }
    var api = drawerApi();
    if (!api || typeof api.toggleUpsell !== 'function') {
      errorMessage = 'Your cart is still loading. Please try again.';
      render(latestCart());
      return;
    }
    var action = {
      id: id,
      checked: checkbox.checked,
      revision: interactionRevision,
      focus: document.activeElement === checkbox || checkbox.closest('label').contains(document.activeElement)
    };
    pending = action;
    errorMessage = '';
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('[data-ss-cu-check]').forEach(function (input) { input.disabled = true; });
    var error = section.querySelector('.ss-cu__error');
    if (error) { error.textContent = ''; error.hidden = true; }
    status(action.checked ? 'Adding your matching bracelet…' : 'Removing the added bracelet…');
    try {
      var result = await api.toggleUpsell(id, action.checked, catalogFor(block()) || catalog);
      if (validCart(result)) currentCart = result;
      pending = null;
      render(validCart(result) ? result : latestCart());
      status(action.checked ? 'Matching bracelet added to your cart.' : 'The bracelet added here was removed.');
    } catch (failure) {
      pending = null;
      errorMessage = failure && failure.message ? String(failure.message) : 'Your cart could not be updated. Please try again.';
      render(latestCart());
      status('');
    }
    restoreCheckboxFocus(action);
  }

  function onClick(event) {
    var button = event.target.closest && event.target.closest('.ss-cu__arrow');
    var section = button && button.closest(ROOT);
    if (!section || button.disabled) return;
    event.preventDefault();
    var track = section.querySelector('.ss-cu__track');
    var card = track && track.querySelector('.ss-cu__card');
    if (!card) return;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 8;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction(button) * (card.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  function boot() {
    currentCart = latestCart();
    render(currentCart);
  }

  document.addEventListener('change', onChange);
  document.addEventListener('click', onClick);
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track.matches || !track.matches('.ss-cu__track')) return;
    var section = track.closest(ROOT);
    if (!section) return;
    savedScroll = track.scrollLeft;
    lastTrack = track;
    updateArrows(section);
  }, true);
  document.addEventListener('pointerdown', function () { interactionRevision += 1; }, true);
  document.addEventListener('keydown', function () { interactionRevision += 1; }, true);
  document.addEventListener('soulyshine:cart:updated', function (event) {
    render(event.detail && event.detail.cart || latestCart());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
